import posthog from "posthog-js";

let started = false;

export const initAnalytics = () => {
  if (started) return;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) return;
  posthog.init(key, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com",
    capture_pageview: "history_change",
    autocapture: true,
    person_profiles: "identified_only",
  });
  started = true;
};

export const track = (event, props) => {
  try { if (started) posthog.capture(event, props); } catch (e) { /* noop */ }
};

export const identifyUser = (id, props) => {
  try { if (started && id) posthog.identify(id, props); } catch (e) { /* noop */ }
};

export const resetAnalytics = () => {
  try { if (started) posthog.reset(); } catch (e) { /* noop */ }
};
